import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api--source/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import classNames from "classnames";
import React from "react";
import { brandPage } from "@faire/retailer-visitor-shared/paths/index";
import { useSettingLoggedOutHomepageRedesignV2 } from "@faire/retailer/settings/useSettingLoggedOutHomepageRedesignV2";
import { LoggedOutHomeImage } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/__internal__/LoggedOutHomeImage/LoggedOutHomeImage";
var MOBILE_BANNER_SIZE = 311;
var TABLET_BANNER_HEIGHT = 413;
var TABLET_BANNER_WIDTH = 440;
var DESKTOP_BANNER_SIZE = 455;
var XL_DESKTOP_BANNER_HEIGHT = 500;
var XL_DESKTOP_BANNER_WIDTH = 640;
var XXL_DESKTOP_BANNER_HEIGHT = 635;
var XXL_DESKTOP_BANNER_WIDTH = 824;
export var BrandValueBannerBrandInfo = function(param) {
    var brandInfo = param.brandInfo, className = param.className;
    if (!brandInfo) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Flex, {
        className: classNames("w-full flex-col gap-6 pb-12 pt-10 md:flex-row md:gap-8 lg:gap-14", className),
        children: [
            /*#__PURE__*/ _jsx(LoggedOutHomeImage, {
                lazyLoad: true,
                className: "relative size-full md:h-[413px] md:w-[440px] lg:size-[455px] xl:h-[500px] xl:w-[640px] 2xl:h-[635px] 2xl:w-[824px]",
                responsiveImage: {
                    mobileAndAbove: IImage.build({
                        url: brandInfo.image
                    })
                },
                optimizeImageOptions: {
                    mobileAndAbove: {
                        width: MOBILE_BANNER_SIZE,
                        height: MOBILE_BANNER_SIZE
                    },
                    tabletAndAbove: {
                        width: TABLET_BANNER_WIDTH,
                        height: TABLET_BANNER_HEIGHT,
                        resizeMethod: "fill"
                    },
                    desktopAndAbove: {
                        width: DESKTOP_BANNER_SIZE,
                        height: DESKTOP_BANNER_SIZE
                    },
                    xLargeAndAbove: {
                        width: XL_DESKTOP_BANNER_WIDTH,
                        height: XL_DESKTOP_BANNER_HEIGHT,
                        resizeMethod: "fill"
                    },
                    xxLargeDesktop: {
                        width: XXL_DESKTOP_BANNER_WIDTH,
                        height: XXL_DESKTOP_BANNER_HEIGHT,
                        resizeMethod: "fill"
                    }
                }
            }),
            /*#__PURE__*/ _jsx(RightColumn, {
                brandInfo: brandInfo
            })
        ]
    });
};
var RightColumn = function(param) {
    var brandInfo = param.brandInfo;
    var homepageRedesignVariant = useSettingLoggedOutHomepageRedesignV2();
    var name = brandInfo.name, location = brandInfo.location, description = brandInfo.description, cta = brandInfo.cta, token = brandInfo.token;
    return /*#__PURE__*/ _jsxs(Column, {
        className: "relative pt-2 md:h-[413px] md:flex-1 lg:h-[455px] lg:pr-10 xl:h-[500px] xl:pr-20 2xl:h-[635px] 2xl:pr-[200px]",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subheadingSansMedium",
                className: "text-sm tracking-[0.15px] lg:text-lg xl:text-2xl 2xl:text-3xl",
                children: description
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: {
                    mobileAndAbove: "4x",
                    tabletAndAbove: "3x"
                }
            }),
            token ? /*#__PURE__*/ _jsx(Button, {
                variant: "tertiary",
                className: "!justify-start",
                linkTo: brandPage(token),
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "subheadingSansMedium",
                    className: "text-sm underline lg:text-lg",
                    children: name
                })
            }) : /*#__PURE__*/ _jsx(Typography, {
                variant: "subheadingSansMedium",
                className: "text-sm underline lg:text-lg",
                children: name
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansRegular",
                children: location
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "h-8 w-full md:max-h-6 md:min-h-6 md:flex-1 lg:max-h-16 lg:min-h-4"
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "secondary",
                style: {
                    width: "fit-content"
                },
                linkTo: cta.link,
                className: "hover:!bg-core-surface-default !bg-transparent",
                onClick: function() {
                    trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick("brand_value_banner-cta", cta.link, "".concat(homepageRedesignVariant));
                },
                children: cta.name
            })
        ]
    });
};
